function fireConfetti(){
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { x: 0.8, y: 1.0 }
  });
}

jQuery(function (jQuery) {
  let loadedConfetti = false;
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function triggerReactChangeEvent(element, value) {
    var node;
    if (element instanceof $) {
      if (element.length == 0) return;
      node = element[0];
    } else if (element instanceof window.HTMLElement) {
      node = element;
    }
    var inputTypes = [
      window.HTMLInputElement,
      window.HTMLSelectElement,
      window.HTMLTextAreaElement
    ];
    var index = inputTypes.indexOf(node.__proto__.constructor);
    if (index > -1) {
      var eventType = (index == 1) ? 'change' : 'input';
      var setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;
      var event = new Event(eventType, { bubbles: true });

      setValue.call(node, value);
      node.dispatchEvent(event);
    }
  }

  function getProductConfig() {
    var result = [];
    var product = CPB.getStore().getState().Product;
    var changes = product.userChanges;
    var panels = Object.keys(changes);
    panels.forEach(function(panelId) {
      var title = '';
      product.panels.forEach(function(panel) {
          if(panel.id === panelId) title = panel.title;
      });
      var panel = {
        title: title,
        categories: []
      }
      var categories = Object.keys(changes[panelId]);
      categories.forEach(function(categoryId) {
        var catLayer = changes[panelId][categoryId].layer;
        var selectedOption = catLayer.option;
        var catObj = catLayer.categoryObj;
        var category = {
          title: catObj.title,
          options: []
        }
        catObj.options.forEach(function(option) {
          if(option.id === selectedOption) {
            var title = catObj.type === 'input' ? catLayer.value : option.option.data.label;
            category.options.push({
              title: title,
              sku: option.sku
            });
          }
        });
        panel.categories.push(category);
      });
      result.push(panel);
    });
    return result;
  }

  var customJS = function () {

    function runSmash() {  
      const clear = $(".cpb-reset-button");
      clear.click(function () {
        setTimeout(function () {
          $("#swal2-title").text("Clear Current Filters?");
          $(".swal2-actions .swal2-confirm").click(function () {
            $("html, body").animate(
              { scrollTop: $("#product-builder").offset().top - 150 },
              500
            );
          });
        }, 250);
      });

      var modifyProduct = getUrlParameter('modifyProduct');
      if(modifyProduct.length > 0){
        $(".cpb-product-actions .cpb-product-full-price").show();
      }
      
      var fromRoom = getUrlParameter('fromRoom');
      if(fromRoom.length > 0){
        waitForElm("#product-builder .cpb-panel-categories-container .cpb-category-content .cpb-option-type-img.cpb-active .cpb-img-wrap").then((elm) => {
          let activeOption = $(
            "#product-builder .cpb-panel-categories-container .cpb-category-content .cpb-option-type-img.cpb-active .cpb-img-wrap"
          );

          if(!activeOption.hasClass('is-room-option')){
            activeOption.addClass('is-room-option');
          }
        });

        // Set notice of room options being selected
        waitForElm(".cpb-product-title").then((elm) => {
          let titleElm = $(".cpb-product-title");
          let noticeElm = $(".cpb-room-notice");
          if(titleElm.length){
            if (noticeElm.length == 0) {
              $(".cpb-product-title").after('<div class="cpb-room-notice">Everything is already selected to match the exact drapes Mysha has in her home. You can re select any option to customize your drapes to your personal preference!</div>');
            }
          }
        });
        
        // pre search fabrics
        // waitForElm("input#fabric_search").then((elm) => {
        //   let searchElm = $("input#fabric_search");
        //   if(searchElm.length){
        //     setTimeout(() => {
        //       // Select the input element
        //       const inputElement = document.querySelector('input#fabric_search');
  
        //       // Change the value of the input programmatically
        //       inputElement.value = 'Inspired';
  
        //       // Create a new 'keyup' event
        //       const event = new Event('keyup', {
        //         bubbles: true, // Ensures the event bubbles up through the DOM
        //         cancelable: true // Allows the event to be canceled
        //       });
  
        //       // Dispatch the event on the input element
        //       inputElement.dispatchEvent(event);
        //     }, 2000);
        //   }
        // });
      }

      const prevNavText = $(".cpb-prev-tab-button span");
      prevNavText.html('<svg class="icon"><use xlink:href="#left-arrow" /></svg> <span class="nav-text">Previous</span>');
      const nextNavText = $(
        ".cpb-next-tab-button:not(.cpb-prev-tab-button) span"
      );
      nextNavText.html('<span class="nav-text">Next</span> <svg class="icon"><use xlink:href="#right-arrow" /></svg>');
      const nextNav = $(".cpb-next-tab-button");
      nextNav.click(function () {
        $("html, body").animate(
          { scrollTop: $("#product-builder").offset().top - 150 },
          { 
            duration: 100, 
            complete: function(){
              if($(".measurements").hasClass('cpb-active')){
                $(".cpb-product-actions .cpb-product-full-price").show();
              }
              waitForElm(".trigger-cart").then((elm) => {
                let lastItem = $(".trigger-cart");
                if(lastItem.length){
                  $(".cpb-add-to-cart-button").addClass("show btn-primary");
                  if(!$('#tsparticles').length){
                    $(".cpb-add-to-cart-button").after('<div id="tsparticles"></div>');
                  }
                }
              });
            } 
          }
        );
      });

      function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
      }

      function scrollTo(el) {
        let scrollElement = '';
        let page = $("html, body");
        if(el.length > 1){
          for (let i = 0; i < el.length; i++) {
            waitForElm(".cpb-category." + el[i] + " .cpb-option").then((elm) => {
              let currentItem = $(".cpb-category." + el[i]);
              if (currentItem.length && scrollElement == '') {
                scrollElement = currentItem;
                page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                  page.stop();
                });
                page.animate({ scrollTop: scrollElement.offset().top - 300 }, 250, function(){
                  page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                });
                return currentItem;
              }
            });
          }

        } else {
          waitForElm(".cpb-category." + el + " .cpb-option").then((elm) => {
            let currentItem = $(".cpb-category." + el);
            if (currentItem.length) {
              page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
              });
              page.animate({ scrollTop: currentItem.offset().top - 300 }, 250, function(){
                page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
              });
            }
          })
        }
      }

      function runTriggers() {
        setTimeout(() => {
          let nextTriggers = $(".trigger-next .cpb-option");
          let cartTriggers = $('.trigger-cart-bounce .cpb-option, .cpb-category.has-last .cpb-option[data-option-id="FsGm83r_CP1KgySLG5S0C2TA"], .cpb-option[data-option-id="h4qns4oAWKrkT4aVum5qE29Q"], .cpb-option[data-option-id="baAyMbl8ssAZ3ORoWKBVbZhU"]');
          // let priceTriggers = $(".trigger-price .cpb-option");
          let priceTriggers = $(".measurements");
  
          $(document).off('click').on('click', '.cpb-option', function(e){
            let _ = $(this);
            let id = _.data('option-id');
            let classes = (typeof $('.cpb-option[data-option-id="'+id+'"]').closest('.cpb-category').attr('class') !== "undefined") ? $('.cpb-option[data-option-id="'+id+'"]').closest('.cpb-category').attr('class').split(' ') : [];
            if(typeof classes !== "undefined"){
              let hasId = classes.filter(c => c.includes(id));
              let hasName = classes.filter(c => c.includes('--smash--'));
              let selection = (hasId.length) ? hasId : hasName;

              if(typeof selection !== "undefined"){
                if(typeof selection == "string"){
                  const parts = selection.split('--smash--');
                  scrollTo(parts[1]);
                }

                if(typeof selection == "object"){
                  let selections = selection.map(item => {
                    const parts = item.split('--smash--');
                    return parts[1];
                  });

                  if(selections.length){
                    scrollTo(selections);
                  }
                }
              }
            }
          })
  
          nextTriggers.each(function () {
            $(this).click(function () {
              let next = $(
                ".cpb-product-actions .row .cpb-product-actions-container .cpb-next-tab-button"
              ).not(".cpb-prev-tab-button");
              let prim = $(
                ".cpb-product-actions .row .cpb-product-actions-container .cpb-next-tab-button btn-primary"
              );
              next.addClass("bounce btn-primary");
  
              prim.click(function () {
                $(this).removeClass("btn-primary");
              });
  
              setTimeout(function () {
                next.removeClass("bounce");
              }, 1000);
            });
          });
          cartTriggers.each(function () {
            $(this).click(function () {
              let add = $(".cpb-product-actions .row .cpb-product-actions-container .cpb-add-to-cart-button");
              add.addClass("bounce btn-primary show");

              setCartNotice();

              setTimeout(() => {
                waitForElm("#tsparticles").then((elm) => {
                  let confetti = $("#tsparticles");
                  if(confetti.length && loadedConfetti == false){
                    loadedConfetti = true;
                    fireConfetti();
                  }
                });
  
                setTimeout(function () {
                  add.removeClass("bounce");
                }, 1000);
              }, 250);
            });
          });
          priceTriggers.each(function () {
            $(this).click(function () {
              let add = $(".cpb-product-actions .cpb-product-full-price");
              add.show();
            });
          });
        }, 250);
      }
      runTriggers();

      function runDropdownTriggers(trigger){
        // let dropTriggers = $('.cpb-category[data-category-id="oRLx4uOoSKCh9VTcs-rB6x_C"]');
        let dropTriggers = [
          '_JQL3vG5bF1iD_Qn4HPXT4cG', //
          '3lmLk5q2fuqYy9ArHmmcwsgm', //Rods width fraction
          'oRLx4uOoSKCh9VTcs-rB6x_C', //Rods & romans width
          'lagCKV7bB4snG0u7suzBoxv7', //Romans width fraction
          'NtVFujLJGYB1MQNAafA8ZGuK', //Drapes & Cafe width fraction
          'xMPar04BKgxrY-ULJhG5bKHS', //Drapes rod space right
        ];
        // console.log('changed', trigger, dropTriggers.includes(trigger));

        if(dropTriggers.includes(trigger)){
            let _ = $('.cpb-category.'+trigger);
            let id = _.data('option-id');
            let classes = _.attr('class').split(' ');
            if(typeof classes !== "undefined"){
              let hasId = classes.filter(c => c.includes(id));
              let hasName = classes.filter(c => c.includes('--smash--'));
              let hasCart = classes.filter(c => c.includes('trigger-cart'));
              let hasIgnore = classes.filter(c => c.includes('ignore-scroll'));
              let selection = (hasId.length) ? hasId : hasName;

              // console.log(hasCart.length, hasIgnore.length);

              if(typeof selection !== "undefined"){
                if(hasCart.length > 0){
                  let add = $(".cpb-product-actions .row .cpb-product-actions-container .cpb-add-to-cart-button");
                  add.addClass("bounce btn-primary show");

                  setCartNotice();

                  setTimeout(() => {
                    waitForElm("#tsparticles").then((elm) => {
                      let confetti = $("#tsparticles");
                      if(confetti.length && loadedConfetti == false){
                        loadedConfetti = true;
                        fireConfetti();
                      }
                    });

                    setTimeout(function () {
                      add.removeClass("bounce");
                    }, 1000);
                  }, 250);
                } else if(hasIgnore.length > 0) {
                  return true;
                } else {
                  if(typeof selection == "string"){
                    const parts = selection.split('--smash--');
                    scrollTo(parts[1]);
                  }
  
                  if(typeof selection == "object"){
                    let selections = selection.map(item => {
                      const parts = item.split('--smash--');
                      return parts[1];
                    });
  
                    if(selections.length){
                      scrollTo(selections);
                    }
                  }
                }
              }
            }
        }
      }

      function getSelected(cat, id){
        setTimeout(() => {
          let classes = (typeof $('.cpb-category.'+cat).attr('class') !== "undefined") ? $('.cpb-category.'+cat).attr('class').split(' ') : [];
          let hasId = classes.filter(c => c.includes(id))[0];
          let hasName = classes.filter(c => c.includes('--smash--'))[0];
          let selection = (typeof hasId !== "undefined") ? hasId : hasName;
          if(typeof selection !== "undefined"){
            scrollTo(selection.split('--smash--')[1]);
          }
        }, 500);
      }

      document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", function (e) {
        // scrollToOld(e.detail.newLayers.slice(-1)[0].category);
        let cat = e.detail.newLayers.slice(-1)[0].category;
        let id = e.detail.newLayers.slice(-1)[0].option;
        let dropCat = e.detail.newLayers[0].category;
        let dropOp = e.detail.newLayers[0].option;
        // getSelected(cat, id);
        setLabels();
        setRodDesc();
        setDrapesDesc();
        runDropdownTriggers(dropCat);
        runTriggers();
      }, false);

      // Set Title Icons
      let title = $(".cpb-product-title");
      let titleText = $(".cpb-product-title").text();
      let titleIcon = $(".cpb-product-title #builder_icon");
      if (!titleIcon.length) {
        switch (titleText) {
          case "Cafe Curtains":
            title.prepend(
              '<img id="builder_icon" src="//cdn.shopify.com/s/files/1/0111/8306/3097/files/cafe-pair.png" />'
            );
            break;
          
          case "Drapes":
            title.prepend(
              '<img id="builder_icon" src="//cdn.shopify.com/s/files/1/0111/8306/3097/files/Icon_Style_600x_1_1200x.png" />'
            );
            break;

          case "Romans":
            title.prepend(
              '<img id="builder_icon" src="//cdn.shopify.com/s/files/1/0111/8306/3097/files/roman-outside-ffv.png" />'
            );
            break;

          case "Rods":
            title.prepend(
              '<img id="builder_icon" src="//cdn.shopify.com/s/files/1/0111/8306/3097/files/rod-icon_1.png" />'
            );
            break;

          case "Fabrics":
            title.prepend(
              '<img id="builder_icon" src="//cdn.shopify.com/s/files/1/0111/8306/3097/files/swatch-dots_a4769202-e237-4d2b-a3ac-ed3d7a71c814_1200x.png" />'
            );
            break;

          default:
            break;
        }
      }

      let interval = null;
      let finished = false;

      $(".react-tabs__tab:last-child, .cpb-panel-wrapper .trigger-cart .cpb-option span").click(function () {
        $(".cpb-add-to-cart-button").addClass("show btn-primary");
        runTriggers();
      });
      $(".cpb-option span").click(function () {
        runTriggers();
      });

      $(".cpb-option span, .react-tabs__tab").click(function () {
        finished = false;

        interval = setInterval(() => {
          finished = setLabels();
          if (setLabels()) {
            clearInterval(interval);
            return;
          }
        }, 250);
      });

      function setLabels() {
        // let imgs = ($('.cpb-option-type-multiple .cpb-option-type-img img').length > 0) ? $('.cpb-option-type-multiple .cpb-option-type-img img') : $('.cpb-option__wrapper .cpb-option-type-img img');
        let imgs = $(".cpb-option-tooltip-img, .cpb-option-type-img img").not(
          ".wrapped"
        );
        imgs.each(function () {
          let _ = $(this);
          let alt = _.attr("alt");
          let label = _.siblings(".cpb-option-label").length;
          let imgWrap = _.hasClass("wrapped");
          if (!label && !imgWrap) {
            let text = alt.replace(" $", "</br>$");
            _.addClass("wrapped");
            _.after('<div class="cpb-option-label">' + text + "</div>");
            _.wrap('<div class="cpb-img-wrap"></div>');
          }
        });
        return;
      }
      setLabels();

      function setRodDesc() {
        let drapeIron = 'Our Iron Rods are most popular because of the substantial look and feel.  The matte finish makes it look classic, strong, and traditional.  If doing an operable drape, our iron rings glide effortlessly on the rod.';
        let drapeMetal = 'Our metal rods and accessories have a light feel and look with a slight contemporary vibe.  More of a shiny finish than the iron. Our metal rods are 1 1/8" in diameter.';
        let cafeIron = 'Our Iron rods are our most popular because of the substantial look and feel. The matte finish is classic, strong and traditional. These rods come in a 1/2” diameter.';
        let cafeItalian = 'Our Italian Collection has a light look and has a shiny finish which makes it look more formal and high end.  The Italian Collection is more expensive than the Iron collection. These rods come in a 1/2” diameter.';
        setTimeout(() => {
          if (
            $("body.product-cpb_product .react-tabs__tab.cpb-active").is(
              ":contains('Rod')"
            )
          ) {
            let drapeFirst = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.default-rod-type .cpb-option__wrapper .cpb-option-type-img:first"
            );
            let drapeLast = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.default-rod-type .cpb-option__wrapper .cpb-option-type-img:last"
            );
            let cafeFirst = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.cafe-rod-type .cpb-option__wrapper .cpb-option-type-img:first"
            );
            let cafeLast = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.cafe-rod-type .cpb-option__wrapper .cpb-option-type-img:last"
            );

            let first = (drapeFirst.length) ? drapeFirst : ((cafeFirst.length) ? cafeFirst : 0);
            let last = (drapeLast.length) ? drapeLast : ((cafeLast.length) ? cafeLast : 0);
            let firstText = (drapeFirst.length) ? drapeIron : ((cafeFirst.length) ? cafeIron : '');
            let lastText = (drapeLast.length) ? drapeMetal : ((cafeLast.length) ? cafeItalian : '');
            let firstType = (first) ? first.find(".cpb-option-tooltip-inner > #rod_iron") : 0;
            let lastType = (last) ? last.find(".cpb-option-tooltip-inner > #rod_metal") : 0;

            if (first.length && last.length) {
              if (!firstType.length) {
                first
                  .find(".cpb-option-tooltip-inner > .cpb-option-label")
                  .after(
                    '<div id="rod_iron" class="rod-type">'+firstText+'</div>'
                  );
              }
              if (!lastType.length) {
                last
                  .find(".cpb-option-tooltip-inner > .cpb-option-label")
                  .after(
                    '<div id="rod_metal" class="rod-type">'+lastText+'</div>'
                  );
              }
            }
          }
        }, 250);
      }
      setRodDesc();

      function setCartNotice() {
        const page = $("html, body");
        const noticeText = "That's It! Now Add To Cart!";
        const blockScroll = () => page.stop();
        const scrollEvents = "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove";
      
        if (!$(".cart-notice").length) {
          $(".cpb-panel-categories-container").after(`<div class="cart-notice"><h2>${noticeText}</h2></div>`);
        }
      
        waitForElm(".cart-notice").then(() => {
          const currentItem = $(".cart-notice");
          if (!currentItem.length) return;
      
          // Block user scroll
          page.on(scrollEvents, blockScroll);
      
          setTimeout(() => {
            page.animate({ scrollTop: currentItem.offset().top - 300 }, 250, () => {
              // Unblock user scroll
              page.off(scrollEvents, blockScroll);
            });
          }, 250);
        });
      }
      
      // function setCartNotice() {
      //   let page = $("html, body");
      //   let notice = 'That\'s It! Now Add To Cart!';
      //   let noticeEl = ($('.cart-notice').length) ? true : false;

      //   if(!noticeEl){
      //     $('.cpb-panel-categories-container').after('<div class="cart-notice"><h2>'+notice+'</h2></div>');
      //   }

      //   waitForElm(".cart-notice").then((elm) => {
      //     let currentItem = $(".cart-notice");
      //     if (currentItem.length) {
      //       page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
      //         page.stop();
      //       });
      //       setTimeout(() => {
      //         page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
      //           page.stop();
      //         });
      //         page.animate({ scrollTop: currentItem.offset().top - 300 }, 250, function(){
      //           page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
      //         });
      //       }, 250);
      //     }
      //   });
      // }
      
      function setDrapesDesc() {
        setTimeout(() => {
          if ($("body.product-cpb_product .react-tabs__tab.cpb-active").hasClass('drapes-style')) {
            let twotop = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.drapes-style .cpb-option__wrapper .cpb-option-type-img:nth-child(1)"
            );
            let twofrench = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.drapes-style .cpb-option__wrapper .cpb-option-type-img:nth-child(2)"
            );
            let threefrench = $(
              "#product-builder .cpb-theme-provider .cpb-panel-wrapper .cpb-panel-categories-container > *.drapes-style .cpb-option__wrapper .cpb-option-type-img:nth-child(3)"
            );
            let firstType = twotop.find(".cpb-option-tooltip-inner > #drape_two_top");
            let secondType = twofrench.find(".cpb-option-tooltip-inner > #drape_two_french");
            let thirdType = threefrench.find(".cpb-option-tooltip-inner > #drape_three_french");

            if (twotop.length && twofrench.length && threefrench.length) {
              if (!firstType.length) {
                twotop
                  .find(".cpb-option-tooltip-inner > .cpb-option-label")
                  .after(
                    '<div id="drape_two_top" class="drape-style">Our most popular! This is our signature pleat that is clean, simple, and works with every style of home.</div>'
                  );
              }
              if (!secondType.length) {
                twofrench
                  .find(".cpb-option-tooltip-inner > .cpb-option-label")
                  .after(
                    '<div id="drape_two_french" class="drape-style">Similar to our 2 Finger Top Pleat, but has a more traditional look. Not quite as formal as the 3 Finger French Pleat.</div>'
                  );
              }
              if (!thirdType.length) {
                threefrench
                  .find(".cpb-option-tooltip-inner > .cpb-option-label")
                  .after(
                    '<div id="drape_three_french" class="drape-style">For a more classic and traditional look that can make any room feel elevated and formal.</div>'
                  );
              }
            }
          }
        }, 250);
      }
      setDrapesDesc();

      function priceText() {
        if (!$(".cpb-product-price span").length) {
          $(".cpb-product-price").prepend("<span>Starting At: </span>");
        }
      }
      priceText();

      function hidePrice(hide) {
        if (hide) {
          $(".cpb-product-full-price").hide();
        } else {
          $(".cpb-product-full-price").show();
        }
      }

      if ($(".react-tabs__tab.cpb-active").is(":contains('Fabric')")) {
        let swatches = [];
        const color = $(
          "#product-builder .cpb-panel-categories-container .cpb-category-color.color"
          );
        const searchField =
          '<input type="search" id="fabric_search" placeholder="Search fabrics by name..." />';
          
        // hidePrice(true);
          
        if (color) {
          color.before(searchField);
          const searchFabric = $("#fabric_search");
          let fabrics = null;
          let selected = null;
          let time = null;
          let interval = null;
          let finished = false;

          $(".cpb-option span").click(function () {
            finished = false;

            interval = setInterval(() => {
              finished = setLabels();
              if (setLabels()) {
                clearInterval(interval);
                return;
              }
            }, 250);
          });

          setFabrics();
          document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", setFabrics);

          clear.click(function () {
            setTimeout(function () {
              $(".swal2-actions .swal2-confirm").click(function () {
                searchFabric.val("");
                setFabrics();
              });
            }, 500);
          });

          function sortFabrics(el) {
            el.sort(function (a, b) {
              return $(b).data("fabric") < $(a).data("fabric") ? 1 : -1;
            }).appendTo(
              "#product-builder .cpb-panel-categories-container .all-fabrics .cpb-category-content .cpb-option__wrapper"
            );
          }

          function getLabels(arr) {
            arr.each(function () {
              let _ = $(this);
              _.data(
                "fabric",
                _.find(".cpb-option-label").text().toLowerCase()
              );
            });
            return;
          }

          async function setFabrics() {
            await setLabels();
            fabrics = $(
              "#product-builder .cpb-panel-categories-container .all-fabrics .cpb-category-content .cpb-option-type-img"
            );
            await getLabels(fabrics);
            // await sortFabrics(fabrics);
            await filterFabrics(fabrics);

            await selectFabrics();
          }

          function selectFabrics() {

            if (!$("body").hasClass("fabrics")) {
              return;
            }

            // Move Selected Option to front
            let fabricsListContainer = $(
              "#product-builder .cpb-panel-categories-container .all-fabrics .cpb-category-content .cpb-option__wrapper"
            );
            selected = $(
              "#product-builder .cpb-panel-categories-container .all-fabrics .cpb-category-content .cpb-option-type-img.cpb-active"
            );

            if (selected.length > 0 && !fabricsListContainer.hasClass('moved-selected') && selected.index() != 0) {
              setTimeout(function () {
                fabricsListContainer.addClass('moved-selected');
                selected.prependTo(fabricsListContainer);
              }, 1000);
            }

            // OLD FABRICS BUILDER CART
            if ($(".selected-swatches").length == 0) {
              $(".cpb-product-actions").before(
                '<div class="selected-swatches"></div>'
              );
            }

            setTimeout(function () {
              let clone = selected.clone();
              $(".selected-swatches").empty();
              $(".selected-swatches").append(clone);
            }, 500);
          }

          function filterFabrics(arr) {
            searchFabric.stop().on("keyup", function (e) {
              if (time !== null) {
                clearTimeout(time);
              }
              time = setTimeout(function () {
                let element = e.target.value.toLowerCase();
                let terms = element.split(' ');
                arr.hide();
                arr
                  .filter(function (index) {
                    let label = $(this).data("fabric");
                    return terms.some(t => label.includes(t))
                    // return label.includes(element);
                  })
                  .show();
                selectFabrics();
              }, 500);
            });

            return;
          }
        }
      } else {
        // hidePrice(false);
      }
    }
    setTimeout(runSmash, 250);

    function alignWidths() {
      let f = $(".cpb-category-select.width-fraction");
      let n = $(
        ".cpb-category-select.width .cpb-category-options-container.counter"
      );

      f.appendTo(n);
    }

    document.body.addEventListener(
      "CPB_ON_UPDATE_CURRENT_TAB",
      function (event) {
        runSmash();
      }
    );

    // const newUser = users.filter(user =>
    //   user.login.toLowerCase().includes(element)
    // )

    // const newFabrics = fabrics.filter(fabric =>
    //   fabric.login.toLowerCase().includes(element)
    // )
  };

  /**
   * Function wait CPB DOM elements to show up.
   * Work in modern browsers.
   * And execute callback.
   */
  var cpbLoaded = function () {
    if (jQuery("#react-tabs-1").length > 0) {
      console.log("CPB is loaded");
      
      setTimeout(customJS, 1500);

    } else {
      window.requestAnimationFrame(cpbLoaded);
    }
  };

  cpbLoaded();
});
(function ($) {
  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);

  function init() {
    modifyProductInCartInit();
    preloadImages();
    preventUnload();
  }

  function preventUnload() {
    window.onbeforeunload = function() { return "Your work will be lost."; };
  }

  async function preloadImages() {
    const loadWrapper = $('<div>').attr('style', 'height:0;width:0;overflow:hidden;position:absolute;pointer-events:none;')
    $('body').append(loadWrapper)
    const panels = CPB.getStore().getState().Product.panels
    // console.log('cpb object', CPB.getStore().getState());
    for(let i = 0; i < panels.length; i++) {
      for(let j = 0; j < panels[i].categories.length; j++) {
        if(panels[i].categories[j].display !== 'img') continue
        if(panels[i].categories[j].extraClassName.includes('all-fabrics')) {
          await loadOptions(panels[i].categories[j], 30)
          return
        } else {
          await loadOptions(panels[i].categories[j])     
        }   
      }
    }  

    async function loadOptions(category, limit) {
      const limitTo = limit || category.options.length
      for(let k = 0; k < limitTo; k++) {
        const src = category.options[k].option.data.value;
        await new Promise((res, rej) => {
          const image = new Image(100, 100);
          image.onload = () => {
            loadWrapper.append(image)
            res();
          }
          image.onloaderror = rej
          image.src = src;
        });
      }
    }
  }

  function modifyProductInCartInit() {
    if (window.location.search.indexOf("&modifyProduct=") === -1) return;
    var keyId = window.location.search.split("&modifyProduct=")[1];
    keyId = keyId.split("&")[0];
    var addToCartBtn = $(".cpb-add-to-cart-button");
    addToCartBtn.find("span").html("Update Cart");
    addToCartBtn.addClass("show btn-primary");
    if(!$('#tsparticles').length){
      addToCartBtn.after('<div id="tsparticles"></div>');
    }
    addToCartBtn.on("click", function () {
      window.onbeforeunload = null;
      $.get("/cart/change.js", {
        id: keyId,
        quantity: 0,
      });
    });
  }
})(jQuery);
